import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-grow: 1;
    flex-shrink: 0;
`;

export const SearchWrapper = styled('div')`
    max-width: 328px;
    margin-left: auto;
`;
